// Shared formatting helpers (en-NG / Naira). See docs/02-BUSINESS_LOGIC.md §9.
import type { Product } from './types';

/** ₦ with en-NG grouping, no decimals. e.g. 3760000 → "₦3,760,000" */
export const formatNaira = (amount: number): string =>
  `₦${Number(amount).toLocaleString('en-NG', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

/** Number with en-NG grouping and optional decimals. */
export const formatNumber = (value: number, decimals = 0): string =>
  Number(value).toLocaleString('en-NG', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

/** Litres with an L suffix. e.g. 200 → "200L" */
export const formatLiters = (value: number): string => `${formatNumber(value)}L`;

/** Calibration display. e.g. 1 → "1.0 L/20 L" */
export const formatCalibration = (value: number): string => `${value.toFixed(1)} L/20 L`;

/** Product → chart/chip color. */
export const PRODUCT_COLORS: Record<Product, string> = {
  PMS: '#3b82f6', // petrol — blue
  AGO: '#f59e0b', // diesel — amber
  DPK: '#f97316', // kerosene — orange
  LPG: '#22c55e', // cooking gas — green
};

/** Legacy product name → standardized code (for migrating old data). */
export const LEGACY_PRODUCT_MAP: Record<string, Product> = {
  Petrol: 'PMS',
  Diesel: 'AGO',
  Kerosene: 'DPK',
  Gas: 'LPG',
};
